module.exports = __webpack_public_path__ + "static/media/GoogleSans-Medium.e05f9f8d.woff2";